import React, { useMemo } from "react";
import { format, subMonths } from "date-fns";

const OrdersTable = ({
  clinicSummaries = [],
  dateFilterType,
  onFilterTypeChange,
  customStartDate,
  customEndDate,
  onCustomStartDateChange,
  onCustomEndDateChange,
  onRowClick,
  searchTerm,
  onSearchChange,
  hasNext,
  isLoadingMore,
  onLoadMore,
  selectedClinicIds = [],
  onToggleClinicSelection,
}) => {
  const filteredSummaries = useMemo(() => {
    return clinicSummaries.filter((summary) => {
      const clinicName = summary.clinicName || "";
      const matchesSearch = searchTerm
        ? clinicName.toLowerCase().includes(searchTerm.toLowerCase())
        : true;

      return matchesSearch;
    });
  }, [clinicSummaries, searchTerm]);

  const totalOrders = filteredSummaries.reduce(
    (sum, summary) => sum + (summary.totalOrders || 0),
    0,
  );

  return (
    <>
      <div className="pharmacy-table-toolbar">
        <div className="pharmacy-search">
          <label className="pharmacy-filter-label" htmlFor="pharmacy-search-input">
            Search clinics
          </label>
          <input
            id="pharmacy-search-input"
            type="text"
            value={searchTerm}
            onChange={(event) => onSearchChange?.(event.target.value)}
            placeholder="Search clinics..."
          />
        </div>
        <div className="pharmacy-filter">
          <label className="pharmacy-filter-label" htmlFor="pharmacy-date-filter">
            Date filter
          </label>
          <div className="pharmacy-date-input">
            <select
              id="pharmacy-date-filter"
              value={dateFilterType}
              onChange={(event) => onFilterTypeChange?.(event.target.value)}
            >
              <option value="today">Today</option>
              <option value="current_month">
                {format(new Date(), "MMMM yyyy")}
              </option>
              <option value="last_month">
                {format(subMonths(new Date(), 1), "MMMM yyyy")}
              </option>
              <option value="custom">Custom</option>
            </select>
          </div>
          {dateFilterType === "custom" && (
            <div className="pharmacy-date-input" style={{ marginTop: 8 }}>
              <input
                type="date"
                value={customStartDate}
                max={customEndDate || new Date().toISOString().split("T")[0]}
                onChange={(event) => onCustomStartDateChange?.(event.target.value)}
              />
              <span style={{ margin: "0 8px" }}>to</span>
              <input
                type="date"
                value={customEndDate}
                min={customStartDate || undefined}
                max={new Date().toISOString().split("T")[0]}
                onChange={(event) => onCustomEndDateChange?.(event.target.value)}
              />
            </div>
          )}
        </div>
      </div>

      <div
        className="pharmacy-table-wrapper"
        style={{ maxHeight: "420px", overflowY: "auto" }}
        onScroll={(event) => {
          if (!hasNext || !onLoadMore || isLoadingMore) return;
          const target = event.target;
          if (target.scrollTop + target.clientHeight >= target.scrollHeight - 16) {
            onLoadMore();
          }
        }}
      >
        <table className="pharmacy-table">
          <thead>
            <tr>
              <th />
              <th>Clinic Name</th>
              <th>Location</th>
              <th>Mobile Number</th>
              <th className="text-right">Total Orders</th>
            </tr>
          </thead>
          <tbody>
            {filteredSummaries.length === 0 ? (
              <tr>
                <td colSpan={5} style={{ textAlign: "center", padding: "32px 16px" }}>
                  No clinics found
                </td>
              </tr>
            ) : (
              filteredSummaries.map((summary) => (
                <tr
                  key={summary.clinicId}
                  onClick={() => onRowClick?.(summary.clinicId)}
                  style={{ cursor: onRowClick ? "pointer" : "default" }}
                >
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedClinicIds.includes(summary.clinicId)}
                      onClick={(event) => {
                        // Prevent navigating to clinic details when toggling selection
                        event.stopPropagation();
                      }}
                      onChange={() => {
                        onToggleClinicSelection?.(summary.clinicId);
                      }}
                    />
                  </td>
                  <td className="text-link">{summary.clinicName}</td>
                  <td>{summary.location || "—"}</td>
                  <td>{summary.mobileNumber || "—"}</td>
                  <td className="text-right text-primary">{summary.totalOrders}</td>
                </tr>
              ))
            )}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={4}>
                <strong>Total Orders</strong>
              </td>
              <td className="text-right">
                <div className="pharmacy-total-row">
                  <span className="pharmacy-total-value">{totalOrders}</span>
                  {/* <button
                    type="button"
                    className="pharmacy-button pharmacy-button-primary"
                    onClick={handleSettle}
                  >
                    Settle
                  </button> */}
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </>
  );
};

export default OrdersTable;

